import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="bg-cream py-20 px-6" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-[#e8e0d5] relative" data-id="element-131">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-teal text-white w-12 h-12 rounded-full flex items-center justify-center shadow-md" data-id="element-132">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-133">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" data-id="element-134"></path>
            </svg>
          </div>

          <p className="text-lg md:text-xl text-navy leading-relaxed font-serif italic mb-6 mt-4" data-id="element-135">
            "Estás en la fila de la caja. Tu hijo comienza a gritar, a tirarse
            al suelo o a golpearse los oídos. Sientes cómo las miradas de los
            extraños queman tu espalda. Intentas razonar con él, le pides por
            favor que se detenga, pero es como si no pudiera escucharte."
          </p>

          <p className="text-lg md:text-xl text-navy leading-relaxed font-serif italic" data-id="element-136">
            "Tu corazón late a mil por hora, tus manos tiemblan y sientes esa
            mezcla de vergüenza y desesperación absoluta. El aire se acaba.
            'Otra vez no', piensas."
          </p>
        </motion.div>
      </div>
    </section>;
}